export default __webpack_public_path__ + "svgs/logo-cc03dfd7.svg";